export const appName = "Jamujam";
